var cacheName = 'hello-pwa';

//be careful because 
var filesToCache = [
    //'/',
    //'/index.html',//try to 'cache' the index ans see what happens when changes are pushed
    '/lib/angular/angular.min.js',
    '/lib/angular/angular-ui-router.min.js',
    '/lib/angular/angular-animate.min.js',
    '/lib/angular-bootstrap/ui-bootstrap-tpls-1.3.2.min.js',
    //'/app.min.js',
    '/lib/imagecrop/ng-img-crop.js',
    '/lib/infinite-scroll/infinite-scroll.js',
    '/lib/angular-slider/rzslider.min.js',
    '/lib/angular-hammer/hammer.min.js',
    '/lib/angular-hammer/angular.hammer.js',
    '/lib/odometer/odometer.min.js',
    '/lib/ngDragToReorder/ngDragToReorder.js',
    '/lib/angular/angular.min.js',
    '/lib/fit-text/ng-FitText.min.js',

    //'/bundle.css',
    '/lib/fob-font/style.css',
    '/lib/imagecrop/ng-img-crop.css',
    '/lib/angular-slider/rzslider.min.css',
    '/lib/ngDragToReorder/ng-sortable.min.css'/*,

    '/common/directives/navigation/navigation.template.html',
    '/common/directives/alert/alert.template.html',
    '/common/directives/footer/footer.template.html',
    '/home/home.view.html',
    '/common/directives/userthumb/userthumb.template.html',
    '/home/header.view.html',
    '/home/allfeatures.view.html',
    '/home/firstfeature.view.html',
    '/home/secondfeature.view.html',
    '/auth/subscribe.view.html',
    '/common/directives/tag/tag.template.html',
    '/home/persona.view.html',
    '/html/fraise.html',
    '/html/bacon.html'*/
];

/* Start the service worker and cache all of the app's content */
//this is used for caching when offline
self.addEventListener('install', function(e) {
    e.waitUntil(
        caches.open(cacheName).then(function(cache) {
            //special promise so if one resource fail to load it still continues working
            return Promise.all(
                filesToCache.map(function (url) {
                    return cache.add(url).catch(function (reason) {
                        return console.log(url,"failed: ",String(reason));
                    });
                })
            );
        }, function(e) {
            console.log('the install failed', e);
        })
    );
});

/* Serve cached content when offline */
//this is applied on EVERY resource that can be cached
self.addEventListener('fetch', function(e) {
    e.respondWith(
        caches.match(e.request).then(function(response) {
            return response || fetch(e.request);
        }, function(e) {
            console.log('it failed fetching the files', e);
        })
    );
});